<template>
  <v-app>
    <vue-particles color="#f47936" :moveSpeed="2" linesColor="#ffffff" :clickEffect="false" :hoverEffect="false"
                   :particleSize="3"></vue-particles>
    <v-content class="ltp-bg">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex class="login-position" xs12 sm8 md4>
            <div class="logo-login--wrapper">
              <img class="logo-style" src="../assets/logo_ltp.png">
            </div>
            <v-card fixed class="elevation-10">
              <v-card-text>
                <v-form>
                  <v-text-field required v-model="email" prepend-icon="person" name="login" label="E-mail"
                                @keyup.enter="login"
                                type="text"></v-text-field>
                  <v-text-field required v-model="password" id="password" prepend-icon="lock" name="password"
                                label="Password"
                                @keyup.enter="login"
                                type="password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="pb-20">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize mb-1 mr-1"
                  :loading="is_logging_in"
                  :disabled="is_logging_in"
                  @click="login"
                  round
                  color="primary">Login
                </v-btn>
                OR
                <v-btn
                  class="text-capitalize mb-1 mr-1"
                  :loading="is_logging_in"
                  :disabled="is_logging_in"
                  @click="azureLogin"
                  round
                  color="gray">Sign in with Microsoft
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<style>

  .primary--text {
    color: #0033a0 !important;
    caret-color: #0033a0 !important;
  }

  .toast-top-right {
    top: 70px !important;
    right: 23px !important;
  }

  #particles-js {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
  }

  .logo-login--wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 50px
  }

  .error-color {
    color: red;
  }

  .ltp-bg {
    height: 100vh;
    background: #0033A0;
  }

  input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
    background-color: white !important;
    background-image: none !important;
    color: rgb(0, 0, 0) !important;
  }

  .card__text {
    padding: 20px 25px;
  }

  .card__actions {
    padding: 10px 20px 20px 20px;
  }

  .login-position {
    bottom: 70px;
    position: relative;
  }
</style>

<script>
  import {axiosInstance} from '../axios-auth'
  import {PublicClientApplication} from "@azure/msal-browser";
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      env: process.env.NODE_ENV,
      drawer: null,
      email: '',
      password: '',
      is_logging_in: false,
      account: undefined,
      accessToken: ''
    }),
    props: {
      source: String
    },
    // computed: {
    //   ...mapState({
    //     accessToken: state => state.accessToken
    //   })
    // },
    methods: {
      ...mapMutations(['setAccessToken']),
      login() {
        let self = this
        let url = 'accounts/login/'

        let params = {
          "email": self.email,
          "password": self.password
        };

        self.is_logging_in = true;

        axiosInstance.post(url, params).then(function () {
          self.is_logging_in = false;
          self.$toastr.s("Logged in successfully");
          self.$router.push({
            name: 'home'
          })
        }).catch(function (err) {
          self.is_logging_in = false;
          if (err.response.status === 400) {
            self.$toastr.e(err.response.data.error)
          } else {
            self.$toastr.e(err.response.data.error)
          }
          console.log(err)
        })
      },
      getEnvVar() {
        console.log(this.env);
      },
      authenticateInBackend(token) {
        let self = this
        // Make post request to the api to sign in
        let url = 'accounts/dj-rest-auth/azure/'
        let params = {
          'access_token': token
        }
        self.is_logging_in = true;

        axiosInstance.post(url, params).then(function () {
          self.is_logging_in = false;
          self.$toastr.s("Logged in successfully");
          self.$router.push({
            name: 'home'
          })
          }).catch((err) => {
            self.is_logging_in = false;
            if (err.response.status === 500) {
              self.$toastr.e("Authentication error")
            } else {
              self.$toastr.e(err.response.data.error)
            }
            console.log(err)
          })
      },
      async azureLogin () {
        let self = this
        self.$msalInstance
          .loginPopup({
            scopes: [
              "openid",
              "User.Read"
            ]
          })
          .then(() => {
            // Authenticate with Azure AD
            const myAccounts = self.$msalInstance.getAllAccounts()
            self.account = myAccounts[0]
            // self.$msalInstance.setActiveAccount(self.account);

            let request = {
              scopes: [ "User.Read", "openid" ],
              account: self.account,
              forceRefresh: true
            }

            // Get authorization token
            try {
              self.$msalInstance.acquireTokenSilent(request).then((response) => {
                console.log(response)
                // self.setAccessToken(response.accessToken)
                self.accessToken = response.accessToken
                self.authenticateInBackend(self.accessToken)
              }).catch((error) => {
                console.log(error)
              })
            } catch (error) {
              console.error('Error acquiring token, using interactive mode.', error)
              self.$msalInstance.acquireTokenPopup(request).then((response) => {
                self.accessToken = response.accessToken
                self.authenticateInBackend(self.accessToken)
              }).catch((error) => {
                console.log(error)
              })
            }
          }).catch(error => {
            console.log(`Error during authentication: ${error}`)
          })
      },
    },
    mounted () {
      let self = this
      const accounts = this.$msalInstance.getAllAccounts()
      if (accounts.length === 0) {
        return
      }
      self.account = accounts[0]
      // self.$emitter.emit('login', self.account)
    },

    async created () {
      let self = this
      
      self.$msalInstance = new PublicClientApplication(
        self.$store.state.msalConfig
      )

      self.$emitter.on('login', (account) => {
          self.account = account;
          console.log(account);
        }
      );
      this.$emitter.on('logout', () => {
          console.log('logging out');
          this.account = undefined;
        }
      );
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Login.vue